export const getStaticPricing = (currency: string) => {
    const pricingMap: Record<'INR' | 'USD', { current: number; original: number }> = {
      INR: { current: 199, original: 99},
      USD: { current: 5, original: 2.5 },
    };
    
    return pricingMap[currency as 'INR' | 'USD'] || pricingMap['USD']; // default fallback
  };

  export const getStaticPricingBundle = (currency: string) => {
    const pricingMap: Record<'INR' | 'USD', { current: number; original: number }> = {
      INR: { current: 399, original: 199 },
      USD: { current: 4, original: 2},
    };
    
    return pricingMap[currency as 'INR' | 'USD'] || pricingMap['USD']; // default fallback
  };
  export const getCreditPricing = (currency: string) => {
  const perCreditPriceMap: Record<'INR' | 'USD', number> = {
    INR: 19.9,
    USD: 0.25,
  };

  return perCreditPriceMap[currency as 'INR' | 'USD'] || perCreditPriceMap['USD'];
};

export const getProPricing=(currency:string)=>{
  const pricingMap: Record<'INR' | 'USD', {  monthly: number, monthlydiscounted: number,annual:number,annualdiscounted:number }> = {
    INR: { monthly: 500, monthlydiscounted: 250,annual:5000,annualdiscounted:2500},
    USD: { monthly: 10, monthlydiscounted: 5,annual:100,annualdiscounted:50 },
  };

  return pricingMap[currency as 'INR' | 'USD'] || pricingMap['USD']; 
}